export default __webpack_public_path__ + "static/media/fumiplagas.f9e2ac2c.jpeg";